var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaIzquierdaActivo22X22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38544 10.7315C9.25303 10.886 9.25303 11.114 9.38544 11.2685L14.2718 16.9692C14.5189 17.2575 14.4856 17.6916 14.1973 17.9387C13.909 18.1858 13.475 18.1524 13.2279 17.8641L8.34146 12.1633C7.76769 11.4939 7.76769 10.5061 8.34146 9.83671L13.2279 4.13591C13.475 3.84763 13.909 3.81424 14.1973 4.06135C14.4856 4.30845 14.5189 4.74247 14.2718 5.03075L9.38544 10.7315Z",
    fill: "CurrentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzquierdaActivo22X22);
export default __webpack_public_path__ + "static/media/FLECHA_IZQUIERDA_ACTIVO_22X22.77e979aaf71e593278a22856fc1dddcb.svg";
export { ForwardRef as ReactComponent };